const PrivacyPolicy = () => (
  <div className="container Padding-Top">
    <h1>Privacy Policy</h1>
    <p>
      At HS India, we value your privacy and are committed to protecting your personal information. 
      This Privacy Policy outlines how we collect, use, and safeguard your data when you visit our website 
      or interact with us. By using our website, you agree to the terms described in this policy.
    </p>

    <h3>1. Information We Collect</h3>
    <p>
      We may collect the following types of information when you browse, register, or place orders on our site:
    </p>
    <ul>
      <li><strong>Personal Information:</strong> Name, email address, phone number, billing/shipping address, GST number (if applicable).</li>
      <li><strong>Business Information:</strong> Store name, business registration details, wholesale license, and purchase history.</li>
      <li><strong>Technical Information:</strong> IP address, browser type, device information, and website usage statistics via cookies and analytics tools.</li>
    </ul>

    <h3>2. How We Use Your Information</h3>
    <p>
      The information we collect is used for:
    </p>
    <ul>
      <li>Processing and fulfilling wholesale orders.</li>
      <li>Responding to your inquiries and providing customer support.</li>
      <li>Verifying your business credentials for wholesale eligibility.</li>
      <li>Improving our products, services, and website functionality.</li>
      <li>Sending updates, offers, and promotional communications (only if you opt in).</li>
    </ul>

    <h3>3. Sharing of Information</h3>
    <p>
      We do not sell, rent, or trade your personal information. However, we may share your data with:
    </p>
    <ul>
      <li>Trusted service providers for order fulfillment, shipping, and payment processing.</li>
      <li>Government authorities when required by law or to comply with legal obligations.</li>
    </ul>

    <h3>4. Cookies & Tracking</h3>
    <p>
      Our website uses cookies to enhance user experience, analyze traffic, and personalize content. 
      You can disable cookies through your browser settings, but some site features may not function properly.
    </p>

    <h3>5. Data Security</h3>
    <p>
      We implement reasonable technical and organizational measures to protect your personal information from 
      unauthorized access, use, or disclosure.
    </p>

    <h3>6. Your Rights</h3>
    <p>
      You have the right to request access to, correction of, or deletion of your personal data. 
      To exercise these rights, please contact us directly.
    </p>

    <h3>7. Contact Us</h3>
    <p>
      For questions or concerns about this Privacy Policy, please contact us through our&nbsp; 
      <a href="/contact">Contact Page</a> or email us at <strong>info@hs-india.com</strong>.
    </p>

    <p><em>Last Updated: {new Date().toLocaleDateString()}</em></p>
  </div>
);

export default PrivacyPolicy;